const quote = [{
  desc: '新增、修改报价配置接口',
  options: {
    url: '/insSupplierServiceOrg/addOrUpdateInsSupplierSevOrg',
    method: 'post'
  }
}, {
  desc: '报价配置管理列表接口',
  options: {
    url: '/insSupplierServiceOrg/queryInsSupplierOrgList',
    method: 'post'
  }
}, {
  desc: '查询被占用的工号信息接口',
  options: {
    url: '/insSupplierServiceOrg/queryAvailableJobNoInfo',
    method: 'post'
  }
}, {
  desc: '保存投保方案',
  options: {
    url: '/base/risk/saveRiskSchemes',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询投保方案',
  options: {
    url: '/base/risk/getRiskScheme',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '添加/修改报价配置',
  options: {
    url: '/base/config/addSysConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询报价配置',
  options: {
    url: '/base/config/querySysConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '获取报价工号配置',
  options: {
    url: '/base/config/queryPriceConfigDetail',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询报价保司名单-排序',
  options: {
    url: '/base/priceConfig/querySortSupplier',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '添加报价工号配置',
  options: {
    url: '/base/priceConfig/addPriceConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '修改报价工号配置',
  options: {
    url: '/base/priceConfig/updatePriceConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询报价工号配置',
  options: {
    url: '/base/priceConfig/queryPriceConfig',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '工号列表查询（工号和报价二合一）',
  options: {
    url: '/base/jobno/getJobNoList',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '报价风控列表查询',
  options: {
    url: '/base/riskControl/priceRiskControl',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '报价风控列表导出',
  options: {
    url: '/base/riskControl/priceRiskControlExcel',
    method: 'post',
    baseURL: '/insapi/v3/insured',
    responseType: 'arraybuffer'
  }
}, {
  desc: '报价风控，用户报价禁用，启动',
  options: {
    url: '/base/riskControl/priceLimit',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '获取登录验证码或发送手机验证码',
  options: {
    url: '/base/jobno/getLoginVerifyCode',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询用户报价次数并根据保司分组',
  options: {
    url: '/base/riskControl/supplierPriceRiskControl',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '查询自定义模板',
  options: {
    url: '/price/order/queryOrderTemplate',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}, {
  desc: '新增编辑自定义模板',
  options: {
    url: '/price/order/saveOrderTemplate',
    method: 'post',
    baseURL: '/insapi/v3/insured'
  }
}]
export default quote



// WEBPACK FOOTER //
// ./src/api/quote.js